import { Button, Icon, Panel, PanelBody, PanelRow, TextControl, Notice, ToggleControl } from '@wordpress/components'
import { useSelect, dispatch } from '@wordpress/data'

import { __ } from '@wordpress/i18n'
import WPEditor from '../../fields/WPEditor'

import Tooltip from './Tooltip';

const TabRows = props => {
    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const { updateSettings } = dispatch('WPTravel/Admin');

    const {
        force_enable_tabs } = allData;

    const {
        tabs,
        onContentChange,
        onTabAdd,
        onTabRemove
    } = props
    const defaultTab = { label: __('Tab label', 'wp-travel-pro'), content: __('Tab content goes here', 'wp-travel-pro') }
    return <>
        <div id="wp-travel-tabs-add-new-tab" className="wp-travel-custom-tabs">
            <PanelRow>
                <label>
                    {_wp_travel.setting_strings.tabs.force_enable_tabs}
                    <Tooltip text={_wp_travel.setting_strings.tabs.force_enable_tabs_tooltip}>
                        <span><i className='fa fa-info-circle'></i></span>
                    </Tooltip>
                </label>
                <div id="wp-travel-force-ebnable-tabs" className="wp-travel-field-value">
                    <ToggleControl
                        checked={force_enable_tabs == 'yes'}
                        onChange={() => {
                            updateSettings({
                                ...allData,
                                force_enable_tabs: 'yes' == force_enable_tabs ? 'no' : 'yes'
                            })
                        }}
                    />
                    <p className="description">
                    </p>
                </div>
            </PanelRow>
            {tabs.length < 1 && <Notice isDismissible={false} actions={[{
                    'label': _wp_travel.setting_strings.tabs.add_new_tab,
                    onClick:()=>{
                        onTabAdd(defaultTab)
                    },
                    noDefaultClasses:true,
                    className:'is-link'
                }]}>{_wp_travel.setting_strings.tabs.no_custom_itineraries_tab_found}</Notice>}
            {tabs.length > 0 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => onTabAdd(defaultTab)}>{_wp_travel.setting_strings.tabs.add_new_tab}</Button></PanelRow>}
            {tabs.length > 0 && tabs.map((tab, index) => {
                const { label, default_label, content } = tab
                return <PanelBody key={index} title={label ? label : _wp_travel.setting_strings.tabs.tab_label} icon={() => <Icon icon="more" />} initialOpen={false}>
                    <PanelRow>
                        <label>{_wp_travel.setting_strings.tabs.tab_label}</label>
                        <TextControl
                            value={label}
                            onChange={onContentChange('label', index)}
                        />
                    </PanelRow>
                    <PanelRow>
                        <label htmlFor={`tabs-tab-content-${index}`}>{_wp_travel.setting_strings.tabs.tab_content}</label>
                    </PanelRow>
                    <PanelRow>
                        <WPEditor
                            id={`tabs-tab-content-${index}`}
                            onContentChange={onContentChange('content', index)}
                            value={content}
                        />
                    </PanelRow>
                    <PanelRow className="wp-travel-action-section has-right-padding">
                        <span></span>
                        <Button
                            isDestructive
                            isDefault
                            className="wp-traval-button-danger"
                            onClick={() => {
                                if (!confirm('Are you sure to delete custom tab?')) {
                                    return false;
                                }
                                onTabRemove(index)
                            }
                            }>{__(`- Remove ${label}`)}</Button>
                    </PanelRow>
                </PanelBody>

            })}
            {tabs.length > 1 && <PanelRow className="wp-travel-action-section"><span></span><Button variant="secondary" onClick={() => onTabAdd(defaultTab)}>{_wp_travel.setting_strings.tabs.add_new_tab}</Button></PanelRow>}
        </div>
        <br/><br/>
    </>
}

export default data => {
    const store = useSelect(select => select('WPTravel/Admin'))

    const settings = store.getAllStore()
    const tabs = settings.wp_travel_custom_global_tabs || []
    const force_enable_tabs = settings.wp_travel_custom_global_tabs || []
    const { updateSettings } = dispatch('WPTravel/Admin');

    const { modules, options } = settings;
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_utilities && 'yes' === moduleSettings.show_wp_travel_utilities.value;


    const handleChange = (name, index) => value => {
        let prevTabs = [...tabs]
        prevTabs.splice(index, 1, { ...tabs[index], [name]: value })
        updateSettings({
            ...settings,
            wp_travel_custom_global_tabs: [...prevTabs],
        })
    }

    const handleTabAdd = (tab) => {
        updateSettings({
            ...settings,
            wp_travel_custom_global_tabs: [...tabs, { ...tab }],
        })
    }

    const handleTabRemove = (index) => {
        let prevTabs = [...tabs]
        prevTabs.splice(index, 1)
        updateSettings({
            ...settings,
            wp_travel_custom_global_tabs: [...prevTabs],
        })
    }
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <TabRows
        onContentChange={handleChange}
        tabs={tabs}
        onTabAdd={handleTabAdd}
        onTabRemove={handleTabRemove}
    />
}